export const maxFileSize = 15728640;